import { useGetFreeUsage } from '@/shared/api/generated/subscriptions';

export const useFreeUsage = () => {
  return useGetFreeUsage({
    query: {
      // Non-free users get a 404; don't retry on that.
      retry: false,
    },
  });
};
